const CONCESSIONARIA_LOGO_MAP: Record<string, string> = {
  '01': 'assets/images/concessionarias/01_autoban.png',
  '03': 'assets/images/concessionarias/03_tebe.jpg',
  '05': 'assets/images/concessionarias/05_vianorte.png',
  '06': 'assets/images/concessionarias/06_intervias.jpg',
  '07': 'assets/images/concessionarias/07_rota_das_bandeiras.jpg',
  '08': 'assets/images/concessionarias/08_centrovias.jpg',
  '09': 'assets/images/concessionarias/09_triangulo_do_sol.jpg',
  '10': 'assets/images/concessionarias/10_autovias.jpg',
  '11': 'assets/images/concessionarias/11_renovias.jpg',
  '12': 'assets/images/concessionarias/12_viaoeste.png',
  '13': 'assets/images/concessionarias/13_colinas.jpg',
  '16': 'assets/images/concessionarias/16_cart.jpg',
  '19': 'assets/images/concessionarias/19_viarondon.jpg',
  '20': 'assets/images/concessionarias/20_spvias.png',
  '21': 'assets/images/concessionarias/21_rodovias_do_tiete.jpg',
  '22': 'assets/images/concessionarias/22_ecovias_imigrantes.jpg',
  '23': 'assets/images/concessionarias/23_ecovias_leste_paulista.jpg',
  '24': 'assets/images/concessionarias/24_rodoanel_oeste.png',
  '25': 'assets/images/concessionarias/25_spmar.jpg',
  '26': 'assets/images/concessionarias/26_rodoanel_norte.jpg',
  '27': 'assets/images/concessionarias/27_tamoios.jpg',
  '28': 'assets/images/concessionarias/28_entrevias.jpg',
  '29': 'assets/images/concessionarias/29_viapaulista.jpg',
  '30': 'assets/images/concessionarias/30_eixo_sp.jpg',
  '31': 'assets/images/concessionarias/31_ecovias_noroeste_paulista.png',
  '32': 'assets/images/concessionarias/32_novo_litoral.jpg',
  '33': 'assets/images/concessionarias/33_rota_sorocabana.png',
  '34': 'assets/images/concessionarias/34_raposo_castello.jpg',
  '35': 'assets/images/concessionarias/35_via_raposo.jpg',
  '36': 'assets/images/concessionarias/36_tsg.jpg',
};

export function parseConcessionariaCode(nome: string): string | null {
  const match = /^[A-Za-z]?(\d+)\s*-\s*(.+)$/.exec(nome ?? '');
  return match ? match[1] : null;
}

export function getConcessionariaLogo(nome: string): string | null {
  const code = parseConcessionariaCode(nome);
  return code ? (CONCESSIONARIA_LOGO_MAP[code] ?? null) : null;
}
